import { IRecommendationNearNewbuildingItemSchema } from '../repositories/newbuilding-search/entities/recommendations_near/RecommendationNearNewbuildingItemSchema';
import { IGetRecommendationsNearNewbuildingResponse } from '../repositories/newbuilding-search/v1/get-recommendations-near-newbuilding';
import { IRecommendationNewbuildingInfrastructure } from '../types/map';

export const prepareRecommendationNewbuildingItem = (
  newbuilding: IRecommendationNearNewbuildingItemSchema,
  modelVersion: string,
): IRecommendationNewbuildingInfrastructure => {
  return {
    coordinates: newbuilding.coordinates,
    distance: newbuilding.distance,
    id: `similar_newbuilding_${newbuilding.id}`,
    imageUrl: newbuilding.imageUrl || null,
    minPrice: newbuilding.minPrice || null,
    modelVersion,
    name: newbuilding.name,
    newbuildingId: newbuilding.id,
    roomsSquareMeter: newbuilding.roomsSquareMeter || null,
    type: 'similar_newbuilding',
    url: newbuilding.url,
  };
};

export const transformRecommendationsNearNewbuilding = (
  response: IGetRecommendationsNearNewbuildingResponse,
): IRecommendationNewbuildingInfrastructure[] => {
  const { newbuildings, modelVersion } = response;

  return newbuildings.map(newbuilding => prepareRecommendationNewbuildingItem(newbuilding, modelVersion));
};
